import {
  IonContent,
  IonPage,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
} from '@ionic/react';
import AppHeader from '../components/AppHeader';
import BottomNav from '../components/BottomNav';
import './About.css';

const About: React.FC = () => {
  return (
    <IonPage>
      <AppHeader title="About" showBackButton={true} defaultHref="/profile" />
      <IonContent fullscreen className="ion-padding">
        <div className="about-container">
          <IonCard className="about-card-modern">
            <IonCardHeader>
              <IonCardTitle>🪙 Coin Collector</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <p className="about-description">
                Coin Collector is a rewards platform where you can earn coins by playing games, 
                watching ads, and completing various activities.
              </p>
            </IonCardContent>
          </IonCard>

          <IonCard className="about-card-modern">
            <IonCardHeader>
              <IonCardTitle>How It Works</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-icon-wrapper">
                    <span className="feature-icon">🎮</span>
                  </div>
                  <div className="feature-text">
                    <h3>Play Games</h3>
                    <p>Spin the wheel or play scratch cards to win coins instantly</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon-wrapper">
                    <span className="feature-icon">📺</span>
                  </div>
                  <div className="feature-text">
                    <h3>Watch Ads</h3>
                    <p>Earn coins by watching short video advertisements</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon-wrapper">
                    <span className="feature-icon">💰</span>
                  </div>
                  <div className="feature-text">
                    <h3>Collect Coins</h3>
                    <p>Your coins are automatically added to your wallet</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon-wrapper">
                    <span className="feature-icon">🎁</span>
                  </div>
                  <div className="feature-text">
                    <h3>Redeem Rewards</h3>
                    <p>Coming soon: Exchange coins for real rewards</p>
                  </div>
                </div>
              </div>
            </IonCardContent>
          </IonCard>

          <IonCard className="about-card-modern">
            <IonCardHeader>
              <IonCardTitle>Version</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <div className="version-info">
                <p className="version-text">Version 0.0.1 (MVP)</p>
                <p className="copyright">© 2024 Gulp Games LLC. All rights reserved.</p>
              </div>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
      <BottomNav />
    </IonPage>
  );
};

export default About;

